import { ofType } from 'redux-observable';

import { ajax } from 'rxjs/ajax';

import { of } from 'rxjs';

import { map, switchMap, catchError } from 'rxjs/operators';

import {
  CREATE_NEW_ACCOUNT,
  CREATE_NEW_ACCOUNT_SUCCESS,
  CREATE_NEW_ACCOUNT_FAILED,
} from '../../constants';

import { fetchAccountOverview } from '../../actions/account-actions';
import { pushModal } from '../../actions/modal-actions';
import store from '../../store';

const createAccount = (action$, state$) =>
  action$.pipe(
    ofType(CREATE_NEW_ACCOUNT),
    switchMap(action =>
      ajax({
        url: `${state$.value.auth.server}/accounts?v=${
          process.env.REACT_APP_VERSION
        }`,
        headers: {
          Authorization: state$.value.auth.token,
        },
        responseType: 'json',
        crossDomain: true,
        body: JSON.stringify(action.payload),
        method: 'POST',
      }).pipe(
        map(response => {

          store.dispatch(fetchAccountOverview());
          return {
            type: CREATE_NEW_ACCOUNT_SUCCESS,
            data: response.response,
          };
        }),
        catchError(error => {
          if (error.response.status === 'EMAIL_IN_USE') {
            store.dispatch(
              pushModal({
                title: 'Email Address In Use',
                message:
                  'An account with that email address already exists.',
              })
            );
          }
          return of({
            type: CREATE_NEW_ACCOUNT_FAILED,
            error,
          });
        })
      )
    )
  );

export default createAccount;
